// formSectionsMapper.js



export function mapFormValuesToSections(form) {
  const sections = form?.formType?.formSections ?? [];
  const values = form?.formValues ?? [];

  // quick lookup by fieldId
  const valueById = new Map(values.map(v => [v.formFieldId, v.formData]));

  const sectionsWithValues = sections.map(section => ({
    formSectionId: section.formSectionId,
    name: section.name,
    activeStatus: section.activeStatus,
    isOfficial: section.isOfficial,
    formFields: (section.formFields ?? []).map(field => ({
      formFieldId: field.formFieldId,
      label: field.label,
      required: field.required,
      activeStatus: field.activeStatus,
      formFieldTypeId: field.formFieldTypeId,
      value: valueById.get(field.formFieldId) ?? null,
      isImage:field.isImage,
      imageSize:field.imageSize,
    }))
  }));

  return sectionsWithValues;
}


